import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import { toolTipPointFormatterGenerator, labelFormatterGenerator } from 'helpers/charts';

class GroupedBarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const data = this.props.data;
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        const keys = this.props.keys || Object.keys(data);

        const yAxisOptions = Object.assign({
            labels: {
                formatter: labelFormatterGenerator(this.props.yFormatByType)
            }
        }, this.props.yAxisOptions);

        keys.forEach((key, index) => {
            let completeData;
            if (!this.props.categories) {
                completeData = helpers.backfill(
                    data[key].map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                    this.props.backfillBuckets
                );
            } else {
                completeData = data[key].map(r => r[this.props.y]);
            }

            series.push({
                formatByType: this.props.yFormatByType,
                name: helpers.convertToDisplayValue(key),
                color: orderedColors[index % orderedColors.length],
                data: completeData
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: { categories: this.props.categories }
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel || this.props.y,
            options: {
                ...(yAxisOptions),
            }
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                stacking: null,
                borderWidth: 0
            }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'column',
                            backgroundColor: 'rgba(255, 255, 255, 0.0)',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            },
                            pointFormatter: toolTipPointFormatterGenerator
                        },
                        legend: {
                            padding: 10,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

GroupedBarChart.propTypes = {
    animateDuration: PropTypes.number.isRequired,
    data: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)),
    categories: PropTypes.array,
    exportName: PropTypes.string.isRequired,
    keys: PropTypes.arrayOf(PropTypes.string),
    theme: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    xAxisType: PropTypes.string.isRequired,
    backfillBuckets: PropTypes.array.isRequired,
    y: PropTypes.string.isRequired,
    yFormatByType: PropTypes.string
};

export default withTheme(GroupedBarChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/GroupedBarChart.js